module.exports = __webpack_public_path__ + "static/img/logos_pc.fdd8e6a8.png";